// extracted by mini-css-extract-plugin
export default {"page":"_X-z","cartModal":"aY-z","checkout":"bY-z","placeholder":"cY-z","account":"dY-z"};